// 前端应用配置 - 基于当前域名动态计算
interface AppConfig {
  SERVER_DOMAIN: string;
  API_BASE_URL: string;
  FILES_BASE_URL: string;
  ENVIRONMENT: 'development' | 'production';
}

// 获取当前域名配置
function getCurrentConfig(): AppConfig {
  const hostname = window.location.hostname;
  const protocol = window.location.protocol;
  const port = window.location.port;
  
  // 开发环境检测
  const isDevelopment = 
    import.meta.env.DEV || 
    hostname === 'localhost' || 
    hostname === '127.0.0.1' ||
    port === '3000';
  
  if (isDevelopment) {
    const devDomain = 'https://www.zdtl.top';
    return {
      ENVIRONMENT: 'development',
      SERVER_DOMAIN: devDomain,
      API_BASE_URL: `${devDomain}/api`,
      FILES_BASE_URL: devDomain
    };
  } else {
    // 生产环境：基于当前域名动态计算
    const currentDomain = `${protocol}//${hostname}${port ? `:${port}` : ''}`;
    return {
      ENVIRONMENT: 'production',
      SERVER_DOMAIN: currentDomain,
      API_BASE_URL: `${currentDomain}/api`,
      FILES_BASE_URL: currentDomain
    };
  }
}

const config = getCurrentConfig();

export default config;